import React from 'react';
import { Icon } from './Icon.js';
export const IconLayers = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M17.6114 12L22 14.837L22 15.5L12 21.9645L2.00001 15.5L2 14.837L6.5 11.928", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M22 8.46446L22 9.12747L12 15.5919L2.00002 9.12746L2 8.46445L12 2L22 8.46446Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconLayers.js.map